import photo from '../assets/photo.png'
import scala from '../assets/scala.png'
import python from '../assets/python.png'
import spark from '../assets/spark.png'
import aws from '../assets/aws.png'
import reactNative from '../assets/react-native.png'
import flutter from '../assets/flutter.png'
import react from '../assets/react.png'

const aboutFiles = [
  {
    "year": "Personal",
    "items": [
      {
        "id": 0,
        "name": "Joris TRUONG.png",
        "logo": photo,
        "height": "40%",
        "width": "50%",
        "details": [
          {"key": "Name", "value": "Joris TRUONG"},
          {"key": "Nationality", "value": "France"},
          {"key": "Age", "value": "24"},
          {"key": "Location", "value": "Bussy-St-Georges, Seine-et-Marne, France"},
          {"key": "Languages", "value": "Cantonese, French, English"}
        ]
      },
    ]
  },
  {
    "year": "Technical",
    "items": [
      {
        "id": 1,
        "name": "Scala.png",
        "logo": scala,
        "height": "50%",
        "width": "70%",
        "details": [
          {"key": "Name", "value": "Scala"},
        ]
      },
      {
        "id": 2,
        "name": "Python.png",
        "logo": python,
        "height": "50%",
        "width": "80%",
        "details": [
          {"key": "Name", "value": "Python"},
        ]
      },
      {
        "id": 3,
        "name": "Apache Spark.png",
        "logo": spark,
        "height": "70%",
        "width": "80%",
        "details": [
          {"key": "Name", "value": "Apache Spark"},
        ]
      },
      {
        "id": 4,
        "name": "Amazon Web Services.png",
        "logo": aws,
        "height": "40%",
        "width": "60%",
        "details": [
          {"key": "Name", "value": "Amazon Web Services"},
        ]
      },
      {
        "id": 5,
        "name": "React Native.png",
        "logo": reactNative,
        "height": "30%",
        "width": "60%",
        "details": [
          {"key": "Name", "value": "React Native"},
        ]
      },
      {
        "id": 6,
        "name": "Flutter.png",
        "logo": flutter,
        "height": "40%",
        "width": "60%",
        "details": [
          {"key": "Name", "value": "Flutter"},
        ]
      },
      {
        "id": 7,
        "name": "React.js.png",
        "logo": react,
        "height": "30%",
        "width": "60%",
        "details": [
          {"key": "Name", "value": "React.js"},
        ]
      }
    ]
  }
]

export default aboutFiles;